let purchaseButton = $('.js-purchase-now');

let PURCHASE_FORM_DATA = {
	formBody: null,
};

let zipCodeArray = themeVars['zipArray']

const store = {
	activeBundle: {},
	additionalSelectedServices: [],
};
// window.store = store;

window.Parsley.addValidator('zipcode', {
	validateString: function(value) {
		zipCodeArray.includes(value)
		return zipCodeArray.includes(value);
	},
	messages: {
		en: 'Invalid Zipcode',
	},
});

/* global paypal */

document.addEventListener('DOMContentLoaded', () => {
	/* eslint-disable */
	let isFormOpened = false;
	let pageUrls = window.g_pageUrlMap ? g_pageUrlMap : {};

	const getFormFieldsData = form => {
		return form.serializeArray().reduce(function(obj, item) {
			obj[item.name] = item.value;
			return obj;
		}, {});
	};

	function formResetPart() {
		$('#modal_purchase .service-plans').each(function() {
			$(this).removeClass('visible');
			$(this).removeClass('hidden');
		})
		$('.service-plans-modal__modal-content').removeClass('service-plans-modal__modal-content_service');

		let $steps = $('.order-step'),
		nextStep = 1;

		if ( !$steps.length ) return false;

		$('#payment-form .order-step:not([data-step="1"]) input').each(function() {
			$(this).val('')
		})
		$steps.removeClass('current');
		$steps.hide().filter('[data-step="'+ nextStep +'"]').addClass('current').show();
		isFormOpened = false;
	}

	if (purchaseButton.length) {

		// send notification with data from first step of the purchase form
		async function sendNotification(reasonValue) {
			const form = $('#payment-form');
			let formData = getFormFieldsData(form)
			formData.reason = reasonValue
			let formBody = [];

			for (var property in formData) {
				var encodedKey = encodeURIComponent(property);
				var encodedValue = encodeURIComponent(formData[property]);
				formBody.push(encodedKey + "=" + encodedValue);
			}

			formBody = formBody.join("&");

			if(formBody === PURCHASE_FORM_DATA.formBody) {
				return;
			}

			PURCHASE_FORM_DATA.formBody = formBody;

			let response = await fetch('/wp-json/api/bundle-and-save/notification', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
				},
				body: formBody,
			});

			let result = await response.json();
		}

		function purchasePopupOpen(bundleId, bundleName) {
			let $steps = $('.order-step');
			const bundleMap = g_subscriptionDataMap.bundle_map;
			const bundleSeviceIncludes = g_subscriptionDataMap.bundle_additional_services_includes_map;
			const additionalServiceMap = g_subscriptionDataMap.additional_service_map;
			const bundle = bundleMap[bundleId] || additionalServiceMap[bundleId] || {};

			if ( !$steps.length ) return false;

			store.additionalSelectedServices.length = 0;
			store.activeBundle = { ...bundle, type: bundleName };

			// remove classes from all services
			$('.js-service-item-choose.item-selected').removeClass('item-selected');
			$('#purchase_service_id').val('');
			$('#purchase_bundle_id').val('');
			$('#purchase_bundle_additional_services_id').val('');

			$("body").addClass("fix");
			$('#modal_purchase').fadeIn();
			isFormOpened = true;
			history.replaceState({page: 'Bundle and Save Order Form'}, "Bundle and Save Order Form", pageUrls.order_form)

			if ( 'bundle' === bundleName ) {
				$('#purchase_bundle_id').val(bundleId);
				$('.js-next-step-type').attr('data-next-step', '2');
				$('#modal_purchase .service-plans.items-container').each(function() {
					if($(this).attr('data-id') === bundleId) {
						$(this).addClass('visible');
					}
				});

				bundleSeviceIncludes[bundleId].forEach((item) => {
					$(`#modal_purchase .service-plans.items-choose[data-id='${item}']`).addClass('hidden')
				});
			}
			else if ( 'service' === bundleName ) {
				$('#purchase_service_id').val(bundleId);
				$('#modal_purchase .service-plans.items-container').each(function() {
					if($(this).attr('data-id') === bundleId) {
						$(this).addClass('visible');
					}
				});
				$('.js-next-step-type').attr('data-next-step', '3');
			}

			controllerPricesInHtml();
		}

		purchaseButton.on('click', function () {
			let $this = $(this);
			let $bundleId = $this.attr("data-id");
			let $bundleName = $this.attr("data-service-type");
			purchasePopupOpen($bundleId, $bundleName)
		});

		$('.js-service-item-choose').on('click', function() {
			const id = $(this).attr('data-id');
			const additionalServiceMap = g_subscriptionDataMap.additional_service_map;
			const findIndxAddedService = store.additionalSelectedServices.findIndex((item) => item.id == id);

			if (findIndxAddedService == -1) {
				const service = additionalServiceMap[id];

				if (service) {
					store.additionalSelectedServices.push(service);
				}
			} else {
				store.additionalSelectedServices.splice(findIndxAddedService, 1);
			}

			const str = store.additionalSelectedServices.reduce((acc, item, inx) => {
				return acc + item.id + (inx === store.additionalSelectedServices.length - 1 ? '' : ',');
			}, '');

			$('#purchase_bundle_additional_services_id').val(str);

			controllerPricesInHtml();
			$(this).toggleClass('item-selected');
		})


		function controllerPricesInHtml() {
			const controllers = [
				{
					neededPrice: 'initial_visit_price',
					htmlContainerForRender: '.js-controller-prices',
					rednerPriceElement(bundles) {
						const htmlChildren = bundles.reduce((acc, item) => {
							const price = +item[this.neededPrice];

							return acc +`<div class="service-plans-modal__price-list-item ${item.title == 'Total' ? 'item-total' : ''}">
								<span class="service-plans-modal__price-list-name ">
									${item.title}
								</span>
								<span class="service-plans-modal__price-list-dots"></span>
								<p class="service-plans-modal__price-list-price">
									$${price}
								</p>
							</div>`
						}, '');

						return htmlChildren;
					},
				},
				{
					neededPrice: 'monthly_price',
					htmlContainerForRender: '.js-controller-prices-month',
					rednerPriceElement(bundles) {
						const htmlChildren = bundles.reduce((acc, item) => {
							const price = +item[this.neededPrice];
							const priceElment = `<div class="service-plans-modal__price-list-month-item ${item.title == 'Total' ? 'item-total' : ''}">
								<div class="service-plans-modal__price-list-month-price">
									$${price}/mo
								</div>
								<div class="service-plans-modal__price-list-month-name">
									${item.title}
								</div>
							</div>`;

							const totalElement = `<div class="service-plans-modal__price-list-total-month ${item.title == 'Total' ? 'item-total' : ''}">
								<div class="service-plans-modal__price-list-total-month-name">
									Total monthly charge:
								</div>
								<div class="service-plans-modal__price-list-total-month-price">
									$${price}*<span class="service-plans-modal__price-list-total-month-price_green">/mo</span>
								</div>
							</div>`;

							let renderedElement = item.title == 'Total' ? totalElement : priceElment;

							return acc + renderedElement;
						}, '');

						return htmlChildren;
					},
				},
			]

			controllers.forEach((controller) => {
				initController(controller);
			})

			function initController(controller) {
				if($(controller.htmlContainerForRender)) {
					const activeBundle = store.activeBundle;
					const additionalSelectedServices = store.additionalSelectedServices;
					const bundlePrice = +store.activeBundle[controller.neededPrice] || 0;
					const additionalServicesPrice = store.additionalSelectedServices.reduce((acc, item) => acc + +item[controller.neededPrice], 0) || 0;
					const totalPrice = bundlePrice + additionalServicesPrice;
					const allBundles = [...additionalSelectedServices, { title: 'Total', [controller.neededPrice]: totalPrice }];

					if (activeBundle.type == 'bundle' || controller.htmlContainerForRender == '.js-controller-prices') {
						allBundles.unshift(activeBundle);
					}

					$(controller.htmlContainerForRender).html(controller.rednerPriceElement(allBundles));
				}
			}
		}

		$('#modal_purchase .close-modal').on('click', function () {
			$("body").removeClass("fix");
			$('#modal_purchase').fadeOut(300, () => {
				formResetPart();
				history.replaceState({page: 'Bundle And Save'}, "", pageUrls.base)
			});
		});

		$('#modal_purchase').on("click", function(e) {
			if ($(e.target).is(this) || $(e.target).is('.modal-wrapper')) {
				$("body").removeClass("fix");
				$('#modal_purchase').fadeOut(300, () => {
					history.replaceState({page: 'Bundle And Save'}, "", pageUrls.base)
					formResetPart();
				});
			}
		});

		$('.js-reset-added-service').on('click', function(e) {
			e.preventDefault();

			store.additionalSelectedServices.length = 0;
			controllerPricesInHtml();
		});

		$('.js-next-step').on('click', function (e) {
			e.preventDefault();

			const $this = $(this);
			let nextStep = +$this.attr('data-next-step');
			const form = $('#payment-form');

			form.parsley().validate();
			// FIXME on for production
			if (form.parsley().isValid()) {
				let $steps = $('.order-step');

				if ($('.order-step.current').attr('data-step') === '1') {
					sendNotification()
				}

				if ( !$steps.length ) return false;
				if ($('#purchase_service_id').attr("value")) {
					// $('.service-plans-modal__modal-content').addClass('service-plans-modal__modal-content_service')
				}
				$steps.removeClass('current');
				$steps.hide().filter('[data-step="'+ nextStep +'"]').addClass('current').show();
			}
		});
	}

	let errorMessage = themeVars["errorMessageFormSubscribe"],
		successMessage = themeVars["successMessageFormSubscribe"];

	function formAllReset() {
		$('#modal_purchase .service-plans').each(function() {
			$(this).removeClass('visible');
			$(this).removeClass('hidden');
		});

		$('.service-plans-modal__modal-content').removeClass('service-plans-modal__modal-content_service')
		let $steps = $('.order-step'),
		nextStep = 1;

		if ( !$steps.length ) return false;

		$('#payment-form')[0].reset()
		$steps.hide().filter('[data-step="'+ nextStep +'"]').addClass('current').show();
		window.isFormOpened = false;
	}

	function formPurchaseResult(status, message) {
		$('#modal_purchase').hide();
		if(status === 'success') {
			formAllReset();
			$(".popup-wrapper").append(successMessage);
			PURCHASE_FORM_DATA.formBody = null;
			history.replaceState({page: 'Bundle and Save Order Place'}, "Bundle and Save Order Place", pageUrls.order_placed)
		} else {
			formResetPart();
			$(".popup-wrapper").append(errorMessage);
			$(".error-message__error-text").text(message);
			history.replaceState({page: 'Bundle And Save'}, "", pageUrls.base)
		}

		$(".popup").fadeIn();
		$("body").addClass("fix");
		$('#paypal-card-container').removeClass('hidden');
		$('.confirmButton').removeClass('loading');
		$('.service-plans-modal__form-submitted-message').removeClass('service-plans-modal__form-submitted-message_show');
	}

	const form = $('#payment-form');
	const paymentButton = form.find('.confirmButton');

	function deleteIframeFromCardFiledl() {
		$('#paypal-card-container .card_field').each(function() {
			$(this).find('iframe').remove();
			$(this).removeClass('braintree-hosted-fields-valid')
			$(this).removeClass('braintree-hosted-fields-invalid')
		})
	}

	function addPaypalFields() {
		let orderId;

		$('#paypal-card-container').removeClass('hidden');
		$('.paypal-hostfield-error').removeClass('paypal-hostfield-error_show');

		const createOrder = (/*data, actions*/) => {
			// console.log('Create order!');
			const { bundle_id, service_id, bundle_additional_services_id_list } = getFormFieldsData(form);
			// console.log(form)

			return fetch("/wp-json/api/paypal/order", {
				method: "post",
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ bundle_id, service_id, bundle_additional_services_id_list }),
			})
				.then((res) => res.json())
				.then((orderData) => {
					orderId = orderData.id;
					return orderData.id;
				});
		};

		paypal.HostedFields.render({
			createOrder: createOrder,
			styles: {
				".valid": {
					color: "green",
				},
				".invalid": {
					color: "red",
				},
				"input": {
					'font-size': '20px',
					'padding': '20px',
				},
			},
			fields: {
				number: {
					selector: "#card-number",
					placeholder: "Credit card number",
				},
				cvv: {
					selector: "#cvv",
					placeholder: "Credit card cvv number",
				},
				expirationDate: {
					selector: "#expiration-date",
					placeholder: "MM/YY",
				},
			},
		}).then( cardFields => {
			paymentButton.on("click", event => {
				event.preventDefault();
				paymentButton.attr('disabled', 'disabled')
				setTimeout(() => {
					paymentButton.removeAttr('disabled')
				}, 5000)

				const formData = getFormFieldsData(form);

				let allValidField = false;
				let fieldCounterValid = 0;

				$('.card_field').each(function() {
					if($(this).hasClass('braintree-hosted-fields-valid')) {
						fieldCounterValid++
					}
					if(fieldCounterValid === $('.card_field').length) {
						allValidField = true;
					}
				})

				if(allValidField) {
					$('#paypal-card-container').addClass('hidden');
					$('.confirmButton').addClass('loading');
					$('.service-plans-modal__form-submitted-message').addClass('service-plans-modal__form-submitted-message_show');

					cardFields.submit({
						// Cardholder's first and last name
						cardholderName: `${formData.last_name.toUpperCase()} ${formData.name.toUpperCase()}`,
						// Billing Address
						billingAddress: {
							// Street address, line 1
							streetAddress: formData.address,
							// Street address, line 2 (Ex: Unit, Apartment, etc.)
							extendedAddress: '',
							// State
							region: formData.state,
							// City
							locality: formData.city,
							// Postal Code
							postalCode: formData.zip,
							// Country Code
							countryCodeAlpha2: 'US',
						},
					})
						.then(() => {
							// console.log('Approve order!');
							fetch(`/wp-json/api/paypal/order/${orderId}/capture`, {
								method: "post",
								headers: {
									'Content-Type': 'application/json',
								},
								body: JSON.stringify(formData),
							})
								.then(response => {
									if (!response.ok) {
										throw Error(response.statusText);
									}
									return response;
								})
								.then((res) => res.json())
								.then((orderData) => {
									// Three cases to handle:
									//   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
									//   (2) Other non-recoverable errors -> Show a failure message
									//   (3) Successful transaction -> Show confirmation or thank you
									// This example reads a v2/checkout/orders capture response, propagated from the server
									// You could use a different API or structure for your 'orderData'
									var errorDetail = Array.isArray(orderData.details) && orderData.details[0];

									if (errorDetail && errorDetail.issue === "INSTRUMENT_DECLINED") {
										//return actions.restart(); // Recoverable state, per:
										// https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
									}
									if (errorDetail) {
										var msg = "Sorry, your transaction could not be processed.";
										if (errorDetail.description) {
											msg += "\n\n" + errorDetail.description;
										}
										if (orderData.debug_id) {
											msg += " (" + orderData.debug_id + ")"
										}

										// Show a failure message
										formPurchaseResult('error', msg);
										resetFormState()

										return;
									}

									// Show a success message or redirect
									formPurchaseResult('success', false);
									resetFormState()
								})
								.catch( err => {
									formPurchaseResult('error', err.message);
									resetFormState()
								});
						})
						.catch((err) => {
							formPurchaseResult('error', err.message);
							resetFormState()
						});
				} else {
					return
				}
			});
		});
	}
	function resetFormState() {
		deleteIframeFromCardFiledl();
		setTimeout(() => {
			addPaypalFields();
			paymentButton.removeAttr('disabled')
		}, 500)
	}

	if ( window.paypal && paypal.HostedFields.isEligible() ) {
		addPaypalFields();
	}
	else {
		$('#paypal-card-container').addClass('hidden');
		$('.paypal-hostfield-error').addClass('paypal-hostfield-error_show');
	}

});



// WEBPACK FOOTER //
// ./scripts/modules/page-bundle-and-save.js